import { render } from "./AccountPresetsView.vue?vue&type=template&id=1a4cbfa8&scoped=true"
import script from "./AccountPresetsView.vue?vue&type=script&lang=js"
export * from "./AccountPresetsView.vue?vue&type=script&lang=js"

import "./AccountPresetsView.vue?vue&type=style&index=0&id=1a4cbfa8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a4cbfa8"]])

export default __exports__